<template>
  <div ref="videoContainer" :id="videoFinalId" :style="{ height, width }" />
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { v4 as uuid } from "uuid";
import NIOPlayer from "@nio-fe/nioplayer";

const props = defineProps({
  src: {
    type: String,
    default: "",
  },
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  poster: {
    type: String,
    default: "",
  },
  controller: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  loop: {
    type: Boolean,
    default: true,
  },
  objectFit: {
    type: String,
    default: "contain",
  },
  muted: {
    type: Boolean,
    default: true,
  },
  videoId: {
    type: String,
    default: "",
  },
  pauseOnVideoClick: {
    type: Boolean,
    default: false,
  },
  extraOptions: {
    type: Object,
    default: () => ({}),
  },
});
const videoFinalId = computed(() => {
  return props.videoId || `video-${uuid()}`;
});


onMounted(() => {
  nextTick(() => {
    checkInSwiperDuplicate();
  });
});

const videoContainer = ref();
const videoContext = ref();
const videoContext2 = ref();

const initPlayer = (src: string, posterImage: string, element: any) => {
  if (element) {
    videoContext2.value?.dispose?.();
    videoContext2.value = new NIOPlayer({
      source: src,
      poster: posterImage,
      wasmURL: NIOPlayer.WASM_URL.PROD,
      container: element,
      objectFit: props.objectFit,
      controls: props.controller,
      autoplay: props.autoplay,
      playsinline: true,
      loop: props.loop,
      useNative: false,
      pauseOnVideoClick: props.pauseOnVideoClick,
      ...props.extraOptions,
    });
  } else {
    // 先销毁
    videoContext.value?.dispose?.();
    videoContext.value = new NIOPlayer({
      source: src,
      poster: posterImage,
      wasmURL: NIOPlayer.WASM_URL.PROD,
      container: document.getElementById(videoFinalId.value),
      objectFit: props.objectFit,
      controls: props.controller,
      autoplay: props.autoplay,
      playsinline: true,
      loop: props.loop,
      useNative: false,
      pauseOnVideoClick: props.pauseOnVideoClick,
      ...props.extraOptions,
    });
  }
  // 先销毁
  // videoContext.value?.dispose?.();
};
const play = () => {
  videoContext.value.play?.();
  console.log('---播放---',videoContext2.value);
  
  videoContext2.value?.play?.();
};
const pause = () => {
  videoContext.value.pause?.();
  videoContext2.value?.pause?.();
};
const stop = () => {
  videoContext.value.stop?.();
  videoContext2.value?.stop?.();
};
const reset = () => {
  videoContext.value.seek?.(0);
  videoContext2.value?.seek?.(0);
};

// 向上查找当前父节点是否在swiper-slide-duplicate类中
const checkInSwiperDuplicate = () => {
  const elements = document.querySelectorAll(`#${videoFinalId.value}`);
  elements.forEach((element) => {
    const parent = element.parentElement?.closest(".swiper-slide-duplicate");
    if (parent) {
      initPlayer(props.src, props.poster, element);
    }
  });

};

watch(
  () => props.src,
  (newSrc) => {
    if (newSrc) {
      nextTick(() => {
        initPlayer(newSrc, props.poster, null);
      });
    } else {
      videoContext.value?.dispose?.();
    }
  },
  { immediate: true }
);

defineExpose({
  videoContext,
  videoId: videoFinalId,
  play,
  pause,
  stop,
  reset,
});
</script>

<style scoped lang="scss"></style>
